import React from 'react';

const CarIconSearch = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path d="M6.87342 9.58316H5.20605" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.9043 6.91039L16.6692 6.02753" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.26232 6.91039L2.49658 6.02753" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M14.9602 7.21179L14.1567 3.78377C13.9801 3.02991 13.3076 2.49689 12.5334 2.49689H6.63238C5.85809 2.49689 5.18569 3.02992 5.00901 3.78377L4.20557 7.21179"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6692 10V9.5832C16.6692 8.20191 15.5494 7.08215 14.1681 7.08215H4.99762C3.61634 7.08215 2.49658 8.20191 2.49658 9.5832V13.3348C2.49658 13.7952 2.86983 14.1684 3.33026 14.1684H5.19437C5.6548 14.1684 6.02805 13.7952 6.02805 13.3348V12.0842H9.97553"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.401 12.8249C17.3885 13.8125 17.3885 15.4137 16.401 16.4012C15.4134 17.3888 13.8122 17.3888 12.8247 16.4012C11.8371 15.4137 11.8371 13.8125 12.8246 12.8249C13.2989 12.3507 13.9421 12.0842 14.6128 12.0842C15.2835 12.0842 15.9267 12.3507 16.401 12.8249V12.8249V12.8249"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.4189 16.4194L17.5027 17.5032" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.2925 9.58316H13.9598" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CarIconSearch;
